/*
 * @Author: Dong
 * @Date: 2022-04-07 18:34:45
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-23 16:09:12
 */
import React from 'react';
import Package from 'root/components/FileConfig/Package';
import { PackageDataType, SelectedVersionType, UpdateQueueType } from '../types';

interface PropsType {
  dataSource?: Array<PackageDataType>;
  uploadQueue?: Array<UpdateQueueType>;
  type?: string;
  selectedVersions?: SelectedVersionType;
  changeSelect?: (id: string, name: string) => void;
}

const List = (props: PropsType) => {
  const { dataSource, selectedVersions, changeSelect } = props;

  return (
    <div>
      {(dataSource || []).map((item: any) => {
        const versionOptions = item.specifics || [];

        const { name, specifics = [], isRequired, isOptional, optionDetail } = item;
        const version = selectedVersions ? selectedVersions[name] : '';
        const { img, title, subTitle, disabled, disabledTip, form } = specifics[specifics.length - 1] || {};

        return (
          <Package
            key={name}
            name={name}
            img={img}
            title={title}
            subTitle={subTitle}
            disabledTip={disabledTip}
            formData={form}
            options={versionOptions}
            selectedVersion={version}
            disabled={disabled}
            changeSelect={changeSelect}
            isRequired={isRequired ? true : false}
            isOptional={isOptional}
            optionDetail={optionDetail}
          />
        );
      })}
    </div>
  );
};

export default List;
